module.exports = __webpack_public_path__ + "img/t3-bronze.162bc30e.png";